import {
    AuthGatewayClient,
} from "@mrflark/auth_gateway_sdk";
import {
    SPLClient,
} from "@mrflark/spl_sdk";

export const splClient = new SPLClient({
    endpoint: import.meta.env.VITE_API_URL,
});

export const authGatewayClient = new AuthGatewayClient({
    endpoint: import.meta.env.VITE_AUTH_GATEWAY_URL,
});
